import { useState } from "react";

// userContext
import { UserContext } from "./UserContext.jsx";









export const UserProvider = ({ children }) => {

  // localStorage.setItem("token", "kasgkk");



  // state definition
  const [user, setUser] = useState({});


  const setUserContext = (user = {}) => {
    setUser(user);
  };


  return (
    <UserContext.Provider value={{ user, setUserContext }}>
      {children}
    </UserContext.Provider>
  )
};